import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["steps", "title", "date"]

  connect() {
    this.stepCount = 0
  }

  addStep(event) {
    event.preventDefault()

    const title = this.titleTarget.value.trim()
    const date = this.dateTarget.value

    if (!title || !date) {
      alert("Please enter both title and date.")
      return
    }

    this.stepCount += 1

    const stepElement = document.createElement("div")
    stepElement.className = "flex items-center space-x-4 bg-white p-4 shadow rounded mb-2"

    stepElement.innerHTML = `
      <div class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center">
        ${this.stepCount}
      </div>
      <div>
        <div class="font-semibold">${title}</div>
        <div class="text-sm text-gray-500">${date}</div>
      </div>
    `

    this.stepsTarget.appendChild(stepElement)

    // Clear form
    this.titleTarget.value = ""
    this.dateTarget.value = ""
  }
}
